import React from 'react';

import cn from 'classnames';

import { IConDefaultType } from '../..';

export enum NotificationIconVariant {
  DEFAULT = 'default',
}
export interface INotificationIconProps extends IConDefaultType {
  variant?: NotificationIconVariant;
}

export default function NotificationIcon({
  color = '#303037',
  className,
  size = 20,
  rotate,
  flip,
  variant = NotificationIconVariant.DEFAULT,
}: INotificationIconProps) {
  const style = {
    width: size,
    minWidth: size,
    height: size,
    transform: `rotate(${rotate}deg)`,
  };

  return (
    <i className={cn('dds-icon', className, { flip })} style={style}>
      {variant === NotificationIconVariant.DEFAULT && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM11.3734 6.39747L10.3287 11.6202C10.3287 11.6826 10.2902 11.7273 10.2134 11.7541C10.1365 11.7809 10.0664 11.7942 10.0031 11.7942C9.9307 11.7942 9.85835 11.7831 9.78599 11.7608C9.71363 11.7384 9.67293 11.6916 9.66388 11.6202L8.63277 6.39747C8.56946 6.12071 8.64634 5.84173 8.86342 5.5605C9.08049 5.27928 9.46037 5.13867 10.0031 5.13867C10.5186 5.13867 10.8895 5.28151 11.1156 5.5672C11.3417 5.85288 11.4276 6.12964 11.3734 6.39747ZM11.1157 13.7628C11.1157 14.0574 11.0049 14.3141 10.7833 14.5328C10.5617 14.7515 10.3016 14.8609 10.0031 14.8609C9.70466 14.8609 9.44463 14.7515 9.22303 14.5328C9.00143 14.3141 8.89063 14.0574 8.89063 13.7628C8.89063 13.4503 8.99691 13.1892 9.20946 12.9794C9.42201 12.7696 9.68657 12.6647 10.0031 12.6647C10.3016 12.6647 10.5617 12.774 10.7833 12.9928C11.0049 13.2115 11.1157 13.4682 11.1157 13.7628Z"
            fill={color}
          />
        </svg>
      )}
    </i>
  );
}
